var render = function render(){var _vm=this,_c=_vm._self._c;return _c('aside',{class:{ sidebar: true },attrs:{"id":"sidebar"}},[_c('logo-router',[_c('logo',{attrs:{"custom-logo":_vm.customLogo}})],1),_vm._v(" "),_c('div',{staticClass:"sidebar__items"},[_c('side-nav-sections',{attrs:{"user":_vm.user}}),_vm._v(" "),(_vm.customLogo.hasOwnProperty('file_url'))?_c('bottom-logo'):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }